module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.marketDetails)
  }, [(_vm.race.fileType === 'resultprovisional') ? _c('table', {
    staticClass: "market"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.race.fileType === 'resultfinal') ? _c('table', {
    staticClass: "market"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.race.fileType === 'resultfinal' || _vm.race.fileType === 'resultprovisional') ? _c('table', {
    staticClass: "market"
  }, [(_vm.race.h1) ? _c('tr', {
    staticClass: "market-row"
  }, [_c('td', {
    staticClass: "number"
  }, [_vm._v("\n        1st\n      ")]), _vm._v(" "), _c('td', {
    staticClass: "runner"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n          " + _vm._s(parseInt(_vm.race.h1.num, 10)) + " " + _vm._s(_vm.race.h1.name) + "\n        ")])]), _vm._v(" "), _c('td', {
    staticClass: "name-spacer"
  }), _vm._v(" "), _c('td', {
    staticClass: "price"
  }, [_vm._v("\n        " + _vm._s(_vm.race.h1.startingPrice) + "\n      ")]), _vm._v(" "), _c('td', {
    staticClass: "place"
  }, [(_vm.race.placeData && _vm.race.placeData.placesPaid >= 1) ? _c('div', [_vm._v("\n          " + _vm._s(_vm.placeDisplayPrice(_vm.race.h1, _vm.race.placeData)) + "\n        ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.race.h2) ? _c('tr', {
    staticClass: "market-row"
  }, [_c('td', {
    staticClass: "number"
  }, [_vm._v("\n        2nd\n      ")]), _vm._v(" "), _c('td', {
    staticClass: "runner"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(parseInt(_vm.race.h2.num, 10)))]), _vm._v(" " + _vm._s(_vm.race.h2.name) + "\n        ")])]), _vm._v(" "), _c('td', {
    staticClass: "name-spacer"
  }), _vm._v(" "), _c('td', {
    staticClass: "price"
  }, [_vm._v("\n        " + _vm._s(_vm.race.h2.startingPrice) + "\n      ")]), _vm._v(" "), _c('td', {
    staticClass: "place"
  }, [(_vm.race.placeData && _vm.race.placeData.placesPaid >= 2) ? _c('div', [_vm._v("\n          " + _vm._s(_vm.placeDisplayPrice(_vm.race.h2, _vm.race.placeData)) + "\n        ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.race.h3) ? _c('tr', {
    staticClass: "market-row"
  }, [_c('td', {
    staticClass: "number"
  }, [_vm._v("\n        3rd\n      ")]), _vm._v(" "), _c('td', {
    staticClass: "runner"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n          " + _vm._s(parseInt(_vm.race.h3.num, 10)) + " " + _vm._s(_vm.race.h3.name) + "\n        ")])]), _vm._v(" "), _c('td', {
    staticClass: "name-spacer"
  }), _vm._v(" "), _c('td', {
    staticClass: "price"
  }, [_vm._v("\n        " + _vm._s(_vm.race.h3.startingPrice) + "\n      ")]), _vm._v(" "), _c('td', {
    staticClass: "place"
  }, [(_vm.race.placeData && _vm.race.placeData.placesPaid >= 3) ? _c('div', [_vm._v("\n          " + _vm._s(_vm.placeDisplayPrice(_vm.race.h3, _vm.race.placeData)) + "\n        ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.race.h4) ? _c('tr', {
    staticClass: "market-row"
  }, [_c('td', {
    staticClass: "number"
  }, [_vm._v("\n        4th\n      ")]), _vm._v(" "), _c('td', {
    staticClass: "runner"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n          " + _vm._s(parseInt(_vm.race.h4.num, 10)) + " " + _vm._s(_vm.race.h4.name) + "\n        ")])]), _vm._v(" "), _c('td', {
    staticClass: "name-spacer"
  }), _vm._v(" "), _c('td', {
    staticClass: "price"
  }, [_vm._v("\n        " + _vm._s(_vm.race.h4.startingPrice) + "\n      ")]), _vm._v(" "), _c('td', {
    staticClass: "place"
  }, [(_vm.race.placeData && _vm.race.placeData.placesPaid >= 4) ? _c('div', [_vm._v("\n          " + _vm._s(_vm.placeDisplayPrice(_vm.race.h4, _vm.race.placeData)) + "\n        ")]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.race.fileType === 'racecard') ? _c('table', {
    staticClass: "market"
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "market-row-provisional"
  }, [_c('td', [_c('div', [_vm._v("\n          PROVISIONAL RESULT\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "market-row-final"
  }, [_c('td', [_c('div', [_vm._v("\n          FINAL RESULT\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "market-row"
  }, [_c('td', {
    staticClass: "runner"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n          Awaiting Results\n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f92603e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResultMarket.vue
// module id = 238
// module chunks = 1